import React, { type MouseEvent, type ReactNode } from 'react';
import noop from 'lodash/noop';
import memoizeOne from 'memoize-one';
import HighlightText from '@atlassian/jira-software-highlight-text/src/ui/index.tsx';
import { SummaryAndParentContainer, SummaryWrapper } from '../../styled';
import { SUMMARY_TEST_ID } from '../constants';
import SummaryField from '../summary-field';

export type Props = {
	cardKey: string;
	summary: string;
	highlightText: string | null;
	isUserAtLeastMember: boolean;
	shouldRenderRichCard: boolean;
	isSummaryFieldEditing: boolean;
	onClickThrough: (e: MouseEvent) => void;
	onSummaryEditStateChange: (isEditing: boolean) => void;
	children?: ReactNode;
};

export const SummaryAndParents = ({
	cardKey,
	summary,
	highlightText,
	isUserAtLeastMember,
	shouldRenderRichCard,
	isSummaryFieldEditing,
	onClickThrough,
	onSummaryEditStateChange,
	children,
}: Props) => {
	const getHighlightText = memoizeOne<(highlightedText: string) => Array<string>>(
		(highlightedText) => [highlightedText],
	);

	const highlightTextEl =
		// Possibility that summary is null/undefined
		highlightText !== null && highlightText !== '' && summary ? (
			<HighlightText text={summary} highlight={getHighlightText(highlightText)} />
		) : null;

	return (
		<SummaryAndParentContainer isSummaryFieldEditing={isSummaryFieldEditing}>
			<SummaryWrapper
				tabIndex={-1}
				isSummaryFieldEditing={isSummaryFieldEditing}
				onClick={isSummaryFieldEditing ? noop : onClickThrough}
				data-testid={SUMMARY_TEST_ID}
			>
				<SummaryField
					// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
					issueKey={cardKey!}
					// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
					isUserAtLeastMember={isUserAtLeastMember!}
					shouldRenderRichCard={shouldRenderRichCard ?? false}
					summary={summary}
					highlightText={highlightTextEl}
					onSummaryEditStateChange={onSummaryEditStateChange}
				/>
			</SummaryWrapper>
			{children}
		</SummaryAndParentContainer>
	);
};
